if (!customElements.get('marketing-form')) {
  customElements.define(
    'marketing-form',
    class MarketingForm extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLFormElement | null} */
        this.form = this.querySelector('form');
      }

      connectedCallback() {
        if (this.form) {
          this.form.addEventListener('submit', this.submitHandler.bind(this));
        }
      }

      /**
       * @param {Event} e - The form submit event
       * @returns {Promise<any>} - The response from the server
       */
      async submitHandler(e) {
        e.preventDefault();

        if (!this.form) return;

        this.form.dataset.loading = 'true';

        try {
          /** @type {any} */
          const formElements = this.form.elements;
          const formData = {
            firstName: formElements['firstname'].value.trim(),
            lastName: formElements['lastname'].value.trim(),
            email: formElements['email'].value.trim(),
            birthday: formElements['birthday'].value.trim(),
            gender: formElements['gender'].value.trim(),
            interest: formElements['interest'].value.trim(),
          };

          if (!formData.firstName || !formData.email || !formData.gender) {
            throw new Error('Please fill in all required fields');
          }

          await this.sendToKlaviyo(
            {
              ...formData,
            },
            this.form.id,
          );

          this.dataset.success = 'true';
          this.form.dataset.loading = 'false';
        } catch (/** @type {any} */ error) {
          this.showErrors([error.message]);

          this.form.dataset.loading = 'false';
        }
      }

      /**
       * @param {import('./types').Customer} customer - The customer to send to Klaviyo
       * @param {string} id - The form ID
       * @returns {Promise<void>} - A promise that resolves when the request is complete
       */
      async sendToKlaviyo(customer, id) {
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: customer.email,
                    first_name: customer.firstName,
                    last_name: customer.lastName,
                    external_id: customer.id,
                    properties: {
                      Birthday: customer.birthday,
                      Gender: customer.gender,
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED',
                        },
                      },
                    },
                  },
                },
              },
              custom_source: id,
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: 'YwGeYA',
                },
              },
            },
          },
        };

        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=WCbtTN', {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            Revision: '2025-01-15',
            'Content-Type': 'application/vnd.api+json',
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.errors?.[0]?.detail || 'Unknown error');
        }
      }

      /** @param {string[]} errors - The errors to display */
      showErrors(errors) {
        const errorContainer = this.querySelector('.form-errors');

        if (!errorContainer) return;

        errorContainer.innerHTML = errors.map((/** @type {string} */ error) => `<li>${error}</li>`).join('');
      }
    },
  );
}
